import React, { useMemo, useState, useRef, useCallback, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Button, Modal } from 'react-bootstrap';
import thumbnail from '../../assets/img/crm_home/main-content/thumbnail-user.png';
import { Link, useLocation } from 'react-router-dom';
import apiServices from '../../services/service';
import Loader from '../../shared/component/Loader';
import { getTagsByModule } from '../../redux/selector';
import { useDispatch, useSelector } from 'react-redux';
import Tags from '../sharedChild/tags';
import { toast } from 'react-toastify';
import { fetchDataAndUpdateStore } from '../../redux/actions';

const OptionButton = ({
  handleClickOpenEditForm,
  paramsValue,
  handleOpenViewForm,
  rowData,
  handleClickDelete,
}) => {
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const handleDeleteClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    handleClickDelete(paramsValue);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="action-menu">
      <img
        src="/assets/images/edit.png"
        className="action-img1"
        onClick={() => handleClickOpenEditForm(paramsValue)}
        alt="Edit Opportunity"
        title="Edit Opportunity"
      ></img>

      <img
        src="/assets/images/trash.png"
        className="action-img2"
        onClick={handleDeleteClick}
        alt="Delete Opportunity"
        title="Delete Opportunity"
      ></img>
      <DeleteConfirmationModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
        rowData={rowData}
      />
    </div>
  );
};

const DeleteConfirmationModal = ({ show, handleClose, handleConfirm, rowData }) => {
  return (
    <Modal show={show} onHide={handleClose} className="modal-delete">
      <div className="warning-content">
        <div className="alertImg">
          <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
        </div>
        <div className="warningText">Are you sure you want to delete this tag?</div>
        <div className="warningBtn">
          <Button variant="secondary" className="btn" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn" variant="danger" onClick={handleConfirm}>
            Confirm Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
const ManageTagPage = ({ selectedOptions, handleClose, handleChange }) => {
  const [moduleSelector, setModuleSelector] = useState();

  const location = useLocation();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [formData, setFormData] = useState();

  useEffect(() => {
    setModuleSelector(location.state.module || ''); // Default to empty string if module is not found
  }, [location.state.module]);

  const tagsByModule = useSelector(getTagsByModule(moduleSelector));

  const newtagPopup = () => {
    setShowPopup(!showPopup);
  };
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const tagsInput = {
    module: ['Lead', 'Contact', 'Account', 'Opportunity', 'Campaign'],
  };
  const [rowData, setRowData] = useState([]);
  console.log(rowData);

  const handleInputChange = (e, fieldName) => {
    const value = e.target.value;
    // For other fields, directly update the state
    setFormData((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };

  const gridRef = useRef();

  const columnDefs = [
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <OptionButton
            rowData={paramsValue}
            handleClickOpenEditForm={() => handleClickOpenEditForm(paramsValue)}
            handleClickDelete={() => handleClickDelete(paramsValue)}
          />
        );
      },
      maxWidth: 90,
      sortable: false,
      filter: false,
    },
    {
      headerName: 'Tag Name',
      field: 'name',
      sortable: true,
      filter: true,
      flex: 1,
      cellRenderer: (params) => {
        const { name } = params.data; // Assuming `name` is an array

        return (
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            {/* Map over the `name` array and render each item */}
            {name.map((item, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <div className="tag_arrow arw-right color-tag">
                  {item} {/* Render each item in the array */}
                </div>
              </div>
            ))}
          </div>
        );
      },
    },

    {
      headerName: 'Created By',
      field: 'createdBy',
      sortable: true,
      filter: true,
      flex: 1,
      cellRenderer: (params) => {
        const { createdBy } = params.data;
        return (
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              {/* Image Inside Tag Name */}
              <img
                src={thumbnail}
                alt={`${createdBy} thumbnail`}
                style={{
                  width: '22px',
                  height: '22px',
                  borderRadius: '50%',
                  verticalAlign: 'middle',
                  border: '1px solid #edf2f8',
                }}
              />
              {/* Tag Name */}
              {createdBy}
            </span>
          </div>
        );
      },
    },
  ];

  const handleClickOpenEditForm = (paramsValue) => {
    setIsModalOpen(true); // Show modal
    setFormData(paramsValue);
  };

  const colors = [
    { value: '#ffffff', label: 'White' },
    { value: '#2ecc71', label: 'Green' },
    { value: '#3498db', label: 'Blue' },
    { value: '#9b59b6', label: 'Purple' },
    { value: '#34495e', label: 'Dark Blue' },
    { value: '#1abc9c', label: 'Turquoise' },
    { value: '#e74c3c', label: 'Red' },
    { value: '#7f8c8d', label: 'Grey' },
    { value: '#f1c40f', label: 'Yellow' },
    { value: '#e67e22', label: 'Orange' },
    { value: '#000000', label: 'Black' },
  ];

  const [selectedColor, setSelectedColor] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  const handleClickDelete = (paramsValue) => {
    setLoading(true);

    // Creating the desired JSON object
    let data;
    data = {
      id: paramsValue.id,
      module: location.state.moduleApi,
    };
    apiServices
      .deleteTagsByModule(data)
      .then((response) => {
        if (response.status === 200) {
          if (paramsValue.id === undefined) {
            document.getElementById('massDeleteModal').click();
          }
          dispatch(
            fetchDataAndUpdateStore({
              key: 'tagsByModule',
              inputData: location?.state?.moduleApi,
              storeKey: location?.state?.module,
            })
          );
          setLoading(false);
          toast.success('Record Deleted Successfully!', {
            position: 'top-right',
          });
        } else {
          setLoading(false);
          toast.error('Error deleting record', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
        setLoading(false);
      });
  };

  const handleSubmitTagUpdate = async () => {
    setLoading(true);

    const updatedRow = {
      module: location?.state?.moduleApi,
      id: formData?.id,
      tagName: [formData?.name],
    };

    try {
      const response = await apiServices.updateTags(updatedRow);

      if (response.status === 200) {
        toast.success('Tags Updated Successfully!', { position: 'top-right' });

        setIsModalOpen(false);
        dispatch(
          fetchDataAndUpdateStore({
            key: 'tagsByModule',
            inputData: location?.state?.moduleApi,
            storeKey: location?.state?.module,
          })
        );
      } else {
        toast.error('Failed to update tags.', { position: 'top-right' });
      }
    } catch (error) {
      console.error('Error updating tags:', error);
      toast.error('Failed to update tags.', { position: 'top-right' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container" id="massemailpage">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="manage_tg_container">
                  <svg
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="Warning / Info">
                      <path
                        id="Vector"
                        d="M12 11V16M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM12.0498 8V8.1L11.9502 8.1002V8H12.0498Z"
                        stroke="#456abb"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
                  <p>
                    Tags are keywords that help you categorize your records based on their
                    characteristics. Tags help you sort your data and find it easily when you need
                    it.
                  </p>
                </div>
                <div className="tagBlock">
                  <div className="main-hd" id="newtag_dropdown">
                    <div className="heading_item">
                      <input
                        className="form-control"
                        id="filter-text-box"
                        type="Text"
                        placeholder="Search in Tags..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>

                    <div className="third-div">
                      <div className="heading-item">
                        <button className="add-btn" type="button" onClick={newtagPopup}>
                          New Tag
                        </button>
                      </div>
                    </div>

                    {/* Popup Modal */}
                    {showPopup && (
                      <div id="genricPopup">
                        <div className="popup-overlay">
                          <div className="popup">
                            <div className="popup-header">
                              <h2>Add Tags</h2>
                              <button
                                type="button"
                                className="custom-btn-close"
                                aria-label="Close"
                                onClick={newtagPopup}
                              ></button>
                            </div>

                            <Tags
                              module={location?.state?.moduleApi}
                              handleClose={newtagPopup}
                              View={true}
                              storeKey={location?.state?.module}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {isModalOpen && (
                      <>
                        <div id="genricPopup">
                          <div className="popup-overlay">
                            <div className="popup">
                              <div className="popup-header">
                                <h2>Edit Tags</h2>
                                <button
                                  onClick={() => setIsModalOpen(false)}
                                  type="button"
                                  className="custom-btn-close"
                                ></button>
                              </div>

                              <div className="popup-body pt-0 ">
                                <div className="input-container">
                                  <label className="form-label">Tag Name</label>
                                  <input
                                    value={formData?.name || ''}
                                    onChange={(e) => handleInputChange(e, 'name')}
                                    className="formik-input"
                                    onFocus={(e) => {
                                      e.target.style.borderColor = '#365397';
                                      e.target.style.boxShadow = '0 0 5px rgba(0, 86, 179, 0.3)';
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.borderColor = '#ccc';
                                      e.target.style.boxShadow = 'none';
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="popup-footer">
                                <button
                                  onClick={() => setIsModalOpen(false)}
                                  type="button"
                                  className="btn btn-outline-primary"
                                  id="massUpdateCancel"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => handleSubmitTagUpdate(formData)}
                                  disabled={loading}
                                >
                                  Submit
                                  {loading && (
                                    <span
                                      className="spinner-border spinner-border-sm ms-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="cutome_ag_theme">
                    <div
                      className={`ag-theme-balham tbl_height`}
                      style={{ height: 'calc(100vh - 208px)' }}
                    >
                      <AgGridReact
                        ref={gridRef}
                        rowHeight={35} // Fixed row height
                        domLayout="fixedHeight"
                        columnDefs={columnDefs}
                        rowData={tagsByModule}
                        defaultColDef={{ resizable: true }}
                        animateRows={true}
                        rowSelection="single"
                        alwaysShowVerticalScroll={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ManageTagPage;
